import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';

import { HomePage } from './components/pages/home/HomePage';
import { RegionsPage } from './components/pages/solutions/RegionsPage';
import { ContinentsPage } from './components/pages/continents/ContinentsPage';
import { IndustryPage } from './components/pages/industries/IndustryPage';
// import { LicenceTypePage } from './components/pages/licences/LicenceTypePage';
import { CompanyTypePage } from './components/pages/company/CompanyTypePage';
import { MonthlyVolumePage } from './components/pages/monthlyVolume/MonthlyVolumePage';
import { ThankYouPage } from './components/pages/thankYou/ThankYouPage';
import { WizardStep } from './contexts/WizardContext';
import Form from './components/pages/forms/Form';
import FormSignature from './components/pages/forms/FormSignature';
import { RiskPage } from './components/pages/RiskPage';
import ProposalPage from './components/pages/proposal/ProposalPage';
import { Loading } from './components/pages/Loading';
// import { ProposalApproval } from './components/pages/proposal/ProposalApproval';
import { LicencePopupListPage } from './components/pages/licences/LicencePopupListPage';
import FormOther from './components/pages/forms/FormOther';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter={true}>
      <Switch location={location} key={location.pathname}>
        <Route path={WizardStep.HOME} exact={true} component={HomePage}/>
        <Route path={WizardStep.REGION} exact={true} component={RegionsPage}/>
        <Route path={WizardStep.CONTINENT} exact={true} component={ContinentsPage}/>
        <Route path={WizardStep.INDUSTRY} exact={true} component={IndustryPage}/>
        <Route path={WizardStep.LICENCE_TYPE} exact={true} component={LicencePopupListPage}/>
        <Route path={WizardStep.COMPANY_TYPE} exact={true} component={CompanyTypePage}/>
        <Route path={WizardStep.EXPENDED_MONTHLY_VOLUME} exact={true} component={MonthlyVolumePage}/>
        <Route path={WizardStep.LOADING} exact={true} component={Loading}/>
        <Route path={WizardStep.PROPOSAL} exact={true} component={ProposalPage}/>
        {/*<Route path={WizardStep.PROPOSAL_APPROVAL} exact={true} component={ProposalApproval} />*/}
        <Route path={WizardStep.APPROVAL_FORM} exact={true} component={FormSignature}/>
        <Route path={WizardStep.OTHER_FORM} exact={true} component={FormOther}/>
        <Route path={WizardStep.REJECTION_FORM} exact={true} component={Form}/>
        <Route path={WizardStep.SORRY} exact={true} component={RiskPage}/>
        <Route path={WizardStep.THANK_YOU} exact={true} component={ThankYouPage}/>

        <Redirect to={WizardStep.HOME}/>
      </Switch>
    </AnimatePresence>
  );
}

export default App;
